import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/video/dex.mp4")